    import React, { useEffect } from "react";
    import { useDispatch, useSelector } from "react-redux";
    import { Link } from "react-router-dom";
    import { publicIndexInfo } from "../../actions/publicActions";

    const HomeScreen = () => {
      const dispatch = useDispatch();
      const publicInfo = useSelector((state) => state.publicInfo);
      const { data } = publicInfo;

      const user = useSelector((state) => state.userLogin);
      const { userInfo } = user;

      useEffect(() => {
        if (!data) dispatch(publicIndexInfo());
      }, [dispatch]);

      return (
        <>
          <section className="main-container">


          <div className="hero" style={{backgroundImage: `url("/images/hero.jpg")` }}>
        
            <div class="column text-center">
            <div class="title-style">
                  Générez votre code QR gratuitement  <span style={{padding: "5px" ,backgroundColor:"black", color: "white"}}>Qrcode.tn</span> </div>
          
        
          

            <div class="subtitle">
                <br></br>
    Créez un QR Code dynamic qui ne se périme jamais
      <br></br>
    Menus, entreprise, bannières, cartes de visite    <br></br> modifiez quand vous voulez, sans réimprimer        </div>
          

            <div class="btn-style">
              

              {userInfo ? (
              ""
            ) : (
              <div className="row button-design-container">
                <div className="col-sm-6 homePage">
                  <Link to="/register">
                    <button
                      className="main-btn"
                      style={{ display: "initial", width: "auto" }}
                    >
                    Créer un compte
                    </button>
                  </Link>
                </div>
                <div
                  className="col-sm-6 homePage"
                  style={{
                    textAlign: "left",
                  }}
                >
                  <Link to="/login">
                    <button
                      className="main-btn"
                      style={{ display: "initial", width: "auto" }}
                    >
                      Mon compte
                    </button>
                  </Link>
                </div>
              </div>
            )}

            
            
          
          </div>
          </div>
          </div>

          <section>

          <div className="code">
              <img src="/images/logo.png" alt="codeqr" />
            </div>

            <div className="row col-sm-12">
              <div className="col-sm-4"></div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                }}
                className="col-sm-4"
              >
                <h2>Visiteurs </h2>
                <span style={{ fontSize: "50px", fontWeight: "600" }}>
                  {data ? data.users : 0}
                </span>
              </div>

              <div className="col-sm-4"></div>
            </div>

            
          </section>

          


        {/* Section — Utilisation du QR Code */}
    <section className="section-usecases py-5">
      <h2 className="text-center mb-4">
        Où utiliser <strong>Qrcode.tn</strong> ?
      </h2>

      <div className="container">
        <div className="row g-4">

          {/* Menus Restaurants */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Menus de Restaurants.jpg"
              alt="menu restaurant"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Menus de Restaurants</h4>
            <p>Menus dynamiques, modifiés instantanément, plus besoin de réimprimer.</p>
          </div>

          {/* Cartes de Visite */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Cartes de Visite.jpg"
              alt="carte de visite"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Cartes de Visite</h4>
            <p>Un scan suffit pour partager vos coordonnées, site, réseaux, WhatsApp.</p>
          </div>

          {/* Entreprises */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Entreprises & Marques.jpg"
              alt="entreprise"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Entreprises & Marques</h4>
            <p>Votre site, vos horaires, vos avis et votre contact accessibles partout.</p>
          </div>

          {/* Boutiques / Services (coiffeur, spa, etc.) */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Boutiques & Services.jpg"
              alt="boutique et spa"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Boutiques & Services</h4>
            <p>Idéal pour coiffeurs, cafés, spas ou magasins — affichez vos prix, promos et galerie.</p>
          </div>

          {/* Affichage & Bannières */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Affichage & Bannières.jpg"
              alt="affiche et bannière"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Affichage & Bannières</h4>
            <p>Ajoutez un QR sur vitrine, flyer, panneau ou voiture pour attirer les clients.</p>
          </div>

          {/* Usage Personnel */}
          <div className="col-12 col-md-4 text-center">
            <img
              src="/images/Usage Personnel.jpg"
              alt="usage personnel"
              style={{width:"85%", borderRadius:"10px"}}
            />
            <h4 className="mt-3">Usage Personnel</h4>
            <p>Partagez vos réseaux sociaux en un scan — rapide, moderne et sans application.</p>
          </div>

        </div>
      </div>
    </section>
  </section>



        
          
          

          
          



   {/* Section — Tutoriels vidéo */}
<section className="section-tutorials py-5">
  <h2 className="text-center mb-4">
    Tutoriels — Comment utiliser <strong>Qrcode.tn</strong>
  </h2>

  <div className="container">
    <div className="row g-4">

      {/* Vidéo 1 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/yQhETQdv4kc"
            title="Créer un compte Qrcode.tn"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إنشاء حساب على qrcode.tn
        </h5>
      </div>

      {/* Vidéo 2 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/Ffqp23y4Tfs"
            title="Ajouter menu"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إضافة Menu إلى qrcode.tn
        </h5>
      </div>

      {/* Vidéo 3 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/DrWJjfsQutc"
            title="Paiement et livraison"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إضافة الدفع والتوصيل
        </h5>
      </div>

      {/* Vidéo 4 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/LLvu4_wXdA8"
            title="Ajouter Wifi"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إضافة Wifi إلى qrcode.tn
        </h5>
      </div>

      {/* Vidéo 5 (duplicate as requested) */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/wubLIteYNfQ"
            title="Ajouter promo duplicate"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إضافة Promo 
        </h5>
      </div>

      {/* Vidéo 6 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/joByyeNj3C0"
            title="Réseaux sociaux"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          إضافة وسائل التواصل الاجتماعي
        </h5>
      </div>

      {/* Vidéo 7 */}
      <div className="col-12 col-md-6 col-lg-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/Vk4f-qz8z38"
            title="Tutoriel Qrcode.tn"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <h5 className="mt-2 text-center">
          Tutoriel Qrcode.tn
        </h5>
      </div>

    </div>
  </div>
</section>




          <section class="section-three">
            <h2 class="mt-5 text-center">Nos partners</h2>
            
            <div class="container text-center">
              
              <div class="row mx-auto my-auto justify-content-center">
                  <div id="recipeCarousel" class="carousel slide" data-bs-ride="carousel">
                      <div class="carousel-inner" >
                          <div class="carousel-item active">
                              <div class="carousel-set">
                                  
                                
                                        <div><img src="/images/Clea service recycling.png" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/DONATELLO.jpg" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/Setup Visuels.png" alt="logo" class="img-design"></img></div> 
                              </div>
                          </div>
                          <div class="carousel-item">
                              <div class="carousel-set">
                                  
                                      <div><img src="/images/Clea service recycling.png" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/DONATELLO.jpg" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/Setup Visuels.png" alt="logo" class="img-design"></img></div> 
                                      
                              </div>
                          </div>


                          <div class="carousel-item">
                              <div class="carousel-set">
                                  
                                       <div><img src="/images/Clea service recycling.png" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/DONATELLO.jpg" alt="logo" class="img-design"></img></div> 
                                        <div><img src="/images/Setup Visuels.png" alt="logo" class="img-design"></img></div> 
                              </div>
                          </div>
                        
                        
                          
                          
                      </div>
                      <a class="carousel-control-prev bg-transparent w-aut" href="#recipeCarousel" role="button" data-bs-slide="prev">
                          <span style={{ backgroundColor: "black"}} class="carousel-control-prev-icon" aria-hidden="true"></span>
                      </a>
                      <a class="carousel-control-next bg-transparent w-aut" href="#recipeCarousel" role="button" data-bs-slide="next">
                          <span style={{ backgroundColor: "black"}}class="carousel-control-next-icon" aria-hidden="true"></span>
                      </a>
                  </div>
              </div>
            
          </div>
            
            
            
            
            
            
        
          </section>

        </>
      );
    };

    export default HomeScreen;
